import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { OfflineSurvey } from './common-class/survey';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'Participation';
  ProductTitle: string = '';
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private elementRef: ElementRef,
    private service: ParticipationDataService,
    private offlineSurvey: OfflineSurvey,
  ) {
    let path = environment.baseURL;

    this.service.emitChange(path, true);
  }

  ngOnInit() {
    const head = document.getElementsByTagName('head')[0];
    const styleLoad = document.createElement('style');
    this.ProductTitle = environment.productName;
    styleLoad.id = 'css-loader-app';
    let loaderk12CSS =
      '.line:nth-child(1){background:#F4B639;} .line:nth-child(2){animation-delay:180ms;background:#EF5032;} .line:nth-child(3){animation-delay:360ms;background:#1860A2;} .line:nth-child(4){animation-delay:540ms;background:#63B054;}';
    let loaderCSS =
      '.line:nth-child(1){background: #006259;} .line:nth-child(2){animation-delay:180ms;background:#12bdca;} .line:nth-child(3){animation-delay:360ms;background:#20232a;} .line:nth-child(4){animation-delay:540ms;background:#83C340;}';
    if (this.ProductTitle == 'K12 Insight') {
      styleLoad.appendChild(document.createTextNode(loaderk12CSS.replace(/"/g, '')));
    } else if (this.ProductTitle == 'Sogolytics') {
      styleLoad.appendChild(document.createTextNode(loaderCSS.replace(/"/g, '')));
    }
    head.appendChild(styleLoad);
  }
}
